var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leavetype"},[_c('div',{staticClass:"main-wrapper"},[_c('main-header'),_c('settingsidebar'),_c('div',{staticClass:"page-wrapper"},[_c('div',{staticClass:"content container-fluid"},[_c('headerleavetype'),_c('leavetypecontent')],1),_c('modalleavetype')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }